import { get_token, get_user_details } from "@/router";
import Loader from "@/components/Loader/LoaderView";
import Swal from 'sweetalert2';
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import { client_domain } from "@/main.js";
import { handle_event_list_realtime } from "@/services/eventRealtimeHandlers";
import { handle_portal_events_realtime_publish_toggle } from "@/services/realtimeEventSecondHelper";

/* global jsQR */

const GOOGLE_MAP_API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;

export default {
  components: {
    Loader,
    FullCalendar
  },
  data() {
    return ({
      events: [],
      event_ticket_attendees:[],
      selectedItemId: [],
      selectedEvent:[],
      cbo_domain: false,
      loading: true,
      is_filter_events_loading: false,
      is_user_events_loading: false,
      initial_calendar_built: false,
      calendar_event_index: {},
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
      },
      promo_input: "",
      promo_message: "",
      promo_status: "",
      is_applying: false,
      applied_promo: null,
      fileName: "",
      fileError: "",
      upload_media: null,
      imagePreview: null,
      token_exists: false,
      user_id: null,
      errors: {},
      showExtrasForm: false,
      show_add_extras: true,
      event_link: "",
      event_types: [],
      is_recurring: false,
      recurring_type:'',
      recurring_patterns: [],
      businessName: '',
      isFirstTime: false,
      chapter: '',
      event_type: '',
      eventExtras: [],
      extraForms: [],
      extraItems: [],
      event_id: null,
      event_name: "",
      description: "",
      start_date: "",
      start_time: '',
      is_free:true,
      end_date: "",
      end_time: '',
      rsvp_start_date: "",
      rsvp_start_time: '',
      rsvp_end_date: "",
      rsvp_end_time: '',
      organizer: "",
      location: "",
      map_auto_complete: null,
      map_auto_complete_input: null,
      portal_id: "",
      item_name: '',
      item_description: '',
      item_price: 0,
      availableTickets: [],
      selectedTickets: [],
      event_tickets:[],
      tickets: [],
      assignedTicketIds:[],
      isScanning: false,
      isProcessing :false,
      currentEventId: null,
      my_events:[],
      my_events_page: 1,
      my_events_page_size: 50,
      my_events_has_more: true,
      my_events_total_pages: 0,
      is_my_events_loading: false,
      is_my_events_loading_more: false,
      chapters: [
        "Bedfordview",
        "Edevale",
        "Kempton Park",
        "Kyalami",
        "East Rand",
      ],
      calendarOptions: {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: 'dayGridMonth',
      events: [],
      height: '100%',
      expandRows: true,
      dayMaxEvents: 3,
      moreLinkClick: 'popover',
      views: {
        dayGridMonth: {
          dayHeaderFormat: { weekday: 'short' },
          titleFormat: { month: 'short', year: 'numeric' },
        },
      },
      windowResize: () => {
        const api = this.$refs?.calendar?.getApi?.();
        if (!api) return;
        const targetView = "dayGridMonth";
        if (api.view?.type !== targetView) api.changeView(targetView);
      },
      dateClick: null,
      eventClick: this.handle_event_click
    },
    selected_event: null
    })
  },
  computed: {
  is_loading_events() {
    return !!(this.is_filter_events_loading || this.is_user_events_loading);
  },
  has_valid_basic_info() {
    return !!(this.event_name?.trim() && this.event_type?.id);
  },
  has_valid_location_and_link() {
    const typeName = this.event_type?.name;
    if (!typeName) return false;
    const needsLocation = ['hybrid', 'in person'].includes(typeName);
    const needsLink = ['hybrid', 'online'].includes(typeName);
    if (needsLocation && !this.location?.trim()) return false;
    if (needsLink && !this.event_link?.trim()) return false;
    return true;
  },
  has_valid_dates() {
    const startObj = this.get_event_start_date_time?.();
    if (!startObj) return false;

    // Validate start date+time is not in the past (guard even though inputs have min=...).
    const now = new Date();
    if (startObj < now) return false;

    const shouldValidateEnd = !!this.end_date || !!this.end_time || !!this.show_event_end_date;
    if (shouldValidateEnd) {
      const endObj = this.get_event_end_date_time?.();
      if (!endObj) return false;
      if (startObj >= endObj) return false;
    }

    return true;
  },
  is_valid_event() {
    return this.has_valid_basic_info &&
           this.has_valid_location_and_link &&
           this.has_valid_dates;
  },
  selectedTicketsData() {
    return this.selectedTickets
      .map(id => {
        const t = this.allTickets.find(ticket => Number(ticket.id) === Number(id));
        if (!t) return null;

        // Check if this ticket is already assigned
        const assigned = this.event_tickets?.find(et => Number(et.ticket.id) === Number(id));

        return {
          id: t.id,
          name: t.name,
          price: assigned ? parseFloat(assigned.price) : 0,
          quantity: assigned ? Number(assigned.quantity) : 1,
          start_date: assigned ? assigned.start_date?.substring(0,16) : '',
          end_date: assigned ? assigned.end_date?.substring(0,16) : '',
          readOnly: !!assigned
        };
      })
      .filter(Boolean);
  },
  },
  mounted() {
   setTimeout(() => {
    this.resizeCalendar();
  }, 300);
 
  window.addEventListener('resize', this.resizeCalendar);
    this.user_details = get_user_details();
    this.user_id = this.get_user_id();
    this.token_exists = get_token();
    this.fetchEventTypes();
    this.fetchRecurringTypes();
    this.filter_events();
    this.get_user_events(true);
    this.fetchExtras();
    this.get_all_tickets();
    if (client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }
    this.calendarOptions.dateClick = this.handleDateClick;
    this.calendarOptions.eventClick = this.handle_event_click

    this._realtime_event_handler = (evt) => this.handle_realtime_event(evt);
    window.addEventListener("realtime:event", this._realtime_event_handler);
  },
  watch: {
    selectedExtraText(newVal) {
      this.filterExtras(newVal);
    },
    event_name(newValue) {
      if (newValue.trim()) this.errors.event_name = null;
    },
    location(newValue) {
      if (newValue.trim()) this.errors.location = null;
    },
    organizer(newValue) {
      if (newValue.trim()) this.errors.organizer = null;
    },
    start_date() {
      this.validate_event_date_range?.();
    },
    end_date() {
      this.validate_event_date_range?.();
    },
    rsvp_start_date() {
      this.errors.rsvp_start_date = null;
    },
    rsvp_end_date() {
      this.errors.rsvp_end_date = null;
    },
    event_type: {
      handler(newType) {
        if (newType.name !== "online") {
          this.$nextTick(() => {
            this.initializeMap();

          });
        }
      },
      deep: true
    },
    events: {
      handler() {
        this.$nextTick(() => {
          if ($.fn.DataTable.isDataTable('#rsvpTable')) {
            $('#rsvpTable').DataTable().destroy();
          }

          $('#rsvpTable').DataTable({
            paging: true,
            searching: true,
            ordering: true,
            info: true,
            lengthChange: true,
            pageLength: 10,
            language: {
              paginate: {
                previous: "Previous",
                next: "Next"
              },
              info: "Showing _START_ to _END_ of _TOTAL_ entries",
              infoEmpty: "No entries available"
            }
          });
        });
      },
      deep: true,
      immediate: true
    }
  },
  beforeUnmount() {
  window.removeEventListener('resize', this.resizeCalendar)
  if (this._realtime_event_handler) {
    window.removeEventListener("realtime:event", this._realtime_event_handler);
    this._realtime_event_handler = null;
  }
},
  methods: {
    sync_calendar_api_events(entries) {
      const api = this.$refs?.calendar?.getApi?.();
      if (!api) return;

      api.removeAllEvents();
      (Array.isArray(entries) ? entries : []).forEach((entry) => {
        api.addEvent(entry);
      });
    },
    handle_realtime_event(dom_event) {
      // This page has two lists:
      // - `events`: published portal events
      // - `my_events`: draft/unpublished portal events (`is_published: false`)
      handle_event_list_realtime(this, dom_event, { list_names: ["events", "my_events"] });
      handle_portal_events_realtime_publish_toggle(this, dom_event);
    },
    close_calendar_more_popover() {
      // FullCalendar's "+X more" uses an internal popover. Close it when opening our Bootstrap modal.
      // Use DOM close button to avoid depending on FullCalendar private APIs/version differences.
      try {
        document
          .querySelectorAll(".fc-popover .fc-popover-close, .fc-more-popover .fc-popover-close")
          .forEach((btn) => btn.click());
      } catch (e) {
        // ignore
      }
    },
    get_event_date_only(value) {
      const raw = String(value || "").trim();
      if (!raw) return "";
      return raw.includes("T") ? raw.split("T")[0] : raw.slice(0, 10);
    },
    get_recurring_pattern_id(event) {
      const raw_id =
        event?.recurring_pattern?.recurring_pattern?.id ??
        event?.recurrence_pattern?.recurring_pattern?.id ??
        event?.recurring_pattern?.id ??
        event?.recurrence_pattern?.id ??
        event?.recurring_type?.id ??
        event?.recurrence_pattern ??
        event?.recurring_type ??
        null;

      const numeric_id = Number(raw_id);
      return Number.isFinite(numeric_id) && numeric_id > 0 ? numeric_id : null;
    },
    get_recurring_pattern_object(event) {
      const nested_direct_pattern = event?.recurring_pattern?.recurring_pattern;
      if (nested_direct_pattern && typeof nested_direct_pattern === "object") return nested_direct_pattern;

      const direct_pattern = event?.recurring_pattern;
      if (direct_pattern && typeof direct_pattern === "object") return direct_pattern;

      const nested_alternate_pattern = event?.recurrence_pattern?.recurring_pattern;
      if (nested_alternate_pattern && typeof nested_alternate_pattern === "object") return nested_alternate_pattern;

      const alternate_pattern = event?.recurrence_pattern;
      if (alternate_pattern && typeof alternate_pattern === "object") return alternate_pattern;

      const pattern_id = this.get_recurring_pattern_id(event);
      if (!pattern_id) return null;

      return (this.recurring_patterns || []).find(
        (pattern) => Number(pattern?.id) === pattern_id
      ) || null;
    },
    get_recurring_pattern_label(event) {
      const direct_name =
        event?.recurring_pattern?.recurring_pattern?.name ??
        event?.recurrence_pattern?.recurring_pattern?.name ??
        event?.recurring_pattern?.name ??
        event?.recurrence_pattern?.name ??
        event?.recurring_type?.name;

      if (direct_name) return String(direct_name).trim();

      return String(this.get_recurring_pattern_object(event)?.name || "").trim();
    },
    is_event_recurring(event) {
      const has_recurring_pattern = !!this.get_recurring_pattern_name(event);
      const recurring_flag = event?.is_recurring;
      if (typeof recurring_flag === "string") {
        const normalized = recurring_flag.trim().toLowerCase();
        if (normalized === "true" || normalized === "1" || normalized === "yes") return true;
        if (normalized === "false" || normalized === "0" || normalized === "no") return false;
      }

      if (typeof recurring_flag === "number") {
        if (recurring_flag === 1) return true;
        if (recurring_flag === 0) return false;
      }
      if (typeof recurring_flag === "boolean") {
        return recurring_flag;
      }

      return has_recurring_pattern;
    },
    get_recurring_pattern_name(event) {
      const direct_name = this.get_recurring_pattern_label(event);
      if (direct_name) return direct_name.toLowerCase();

      const raw_type = event?.recurring_type;
      if (typeof raw_type === "string") return raw_type.trim().toLowerCase();

      return "";
    },
    create_calendar_datetime(date_value, time_value) {
      const date_only = this.get_event_date_only(date_value);
      if (!date_only) return null;

      const time_only = String(time_value || "").trim();
      if (!time_only) return date_only;

      const hhmm = time_only.length >= 5 ? time_only.slice(0, 5) : time_only;
      return `${date_only}T${hhmm}`;
    },
    add_days_to_date_string(date_value, days_to_add = 1) {
      const date_only = this.get_event_date_only(date_value);
      if (!date_only) return "";

      const base_date = new Date(`${date_only}T00:00:00`);
      if (Number.isNaN(base_date.getTime())) return "";

      base_date.setDate(base_date.getDate() + Number(days_to_add || 0));
      return `${base_date.getFullYear()}-${String(base_date.getMonth() + 1).padStart(2, "0")}-${String(base_date.getDate()).padStart(2, "0")}`;
    },
    shift_occurrence_date(base_date, pattern_name) {
      const next = new Date(base_date.getTime());
      const normalized_pattern = String(pattern_name || "").trim().toLowerCase();

      if (normalized_pattern.includes("daily") || normalized_pattern.includes("day")) {
        next.setDate(next.getDate() + 1);
        return next;
      }
      if (normalized_pattern.includes("weekly") || normalized_pattern.includes("week")) {
        next.setDate(next.getDate() + 7);
        return next;
      }
      if (normalized_pattern.includes("monthly") || normalized_pattern.includes("month")) {
        next.setMonth(next.getMonth() + 1);
        return next;
      }
      if (normalized_pattern.includes("yearly") || normalized_pattern.includes("year")) {
        next.setFullYear(next.getFullYear() + 1);
        return next;
      }

      return null;
    },
    build_calendar_event(event, occurrence_date = null, occurrence_index = 0) {
      const isDraft = event?.is_published === false;
      const is_generated_recurring_occurrence = !!occurrence_date;
      const start_date = occurrence_date || this.get_event_date_only(event?.start_date);
      const start = is_generated_recurring_occurrence
        ? start_date
        : (this.create_calendar_datetime(start_date, event?.start_time) || start_date);
      let end = is_generated_recurring_occurrence
        ? this.add_days_to_date_string(start_date, 1)
        : this.create_calendar_datetime(start_date, event?.end_time);
      const has_explicit_time = !!String(event?.start_time || "").trim() || !!String(event?.end_time || "").trim();

      if (!is_generated_recurring_occurrence && start && end) {
        const start_obj = new Date(start);
        const end_obj = new Date(end);
        if (!Number.isNaN(start_obj.getTime()) && !Number.isNaN(end_obj.getTime()) && end_obj <= start_obj) {
          end_obj.setDate(end_obj.getDate() + 1);
          end = `${end_obj.getFullYear()}-${String(end_obj.getMonth() + 1).padStart(2, "0")}-${String(end_obj.getDate()).padStart(2, "0")}T${String(end_obj.getHours()).padStart(2, "0")}:${String(end_obj.getMinutes()).padStart(2, "0")}`;
        }
      }

      return ({
        title: event.event_name,
        ...(start ? { start } : { date: event.start_date }),
        ...(end ? { end } : {}),
        allDay: is_generated_recurring_occurrence || !has_explicit_time,
        display: "block",
        id: occurrence_date ? `${event.id}::${occurrence_index}::${occurrence_date}` : String(event.id),
        ...(isDraft ? { classNames: ["bg-warning", "text-dark", "border-warning"] } : {}),
        extendedProps: {
          event,
          source_event_id: event?.id,
          occurrence_date: occurrence_date || null,
          occurrence_start_time: event?.start_time || null,
          occurrence_end_time: event?.end_time || null,
        },
      });
    },
    build_calendar_entries_for_event(event) {
      if (!event?.id) return [];

      const pattern_name = this.get_recurring_pattern_name(event);
      const is_recurring = this.is_event_recurring(event) && !!pattern_name;
      if (!is_recurring) {
        return [this.build_calendar_event(event)];
      }

      const start_date_only = this.get_event_date_only(event?.start_date);
      const end_date_only = this.get_event_date_only(event?.end_date) || start_date_only;
      if (!start_date_only || !end_date_only) {
        return [this.build_calendar_event(event)];
      }

      const range_start = new Date(`${start_date_only}T00:00:00`);
      const range_end = new Date(`${end_date_only}T00:00:00`);
      if (Number.isNaN(range_start.getTime()) || Number.isNaN(range_end.getTime()) || range_end < range_start) {
        return [this.build_calendar_event(event)];
      }

      const entries = [];
      let occurrence_date = new Date(range_start.getTime());
      let occurrence_index = 0;

      while (occurrence_date <= range_end) {
        const occurrence_key = `${occurrence_date.getFullYear()}-${String(occurrence_date.getMonth() + 1).padStart(2, "0")}-${String(occurrence_date.getDate()).padStart(2, "0")}`;
        entries.push(this.build_calendar_event(event, occurrence_key, occurrence_index));

        const next_date = this.shift_occurrence_date(occurrence_date, pattern_name);
        if (!next_date || next_date <= occurrence_date) break;

        occurrence_date = next_date;
        occurrence_index += 1;
      }
      return entries.length ? entries : [this.build_calendar_event(event)];
    },
    rebuild_calendar_index() {
      const index = {};
      (this.calendarOptions?.events || []).forEach((entry, idx) => {
        if (entry?.id != null) Reflect.set(index, String(entry.id), idx);
      });
      this.calendar_event_index = index;
    },
    upsert_calendar_event(event) {
      if (!event?.id) return;
      this.rebuild_calendar_events();
    },
    remove_calendar_event(eventId) {
      if (!eventId) return;
      this.rebuild_calendar_events();
    },
    rebuild_calendar_events() {
      const combined = [];
      const seen = new Set();

      const addEvent = (event) => {
        if (!event?.id) return;
        const idKey = String(event.id);
        if (seen.has(idKey)) return;
        seen.add(idKey);
        combined.push(event);
      };

      (this.events || []).forEach(addEvent);
      (this.my_events || []).forEach(addEvent);

      const next_entries = combined.flatMap((event) => this.build_calendar_entries_for_event(event));
      this.calendarOptions.events = next_entries;
      this.$nextTick(() => {
        this.sync_calendar_api_events(next_entries);
      });
      this.rebuild_calendar_index();
    },
    try_build_initial_calendar() {
      if (this.initial_calendar_built) return;
      if (this.is_filter_events_loading || this.is_user_events_loading) return;
      this.rebuild_calendar_events();
      this.initial_calendar_built = true;
    },
    handle_event_click(click_event){
      const calendar_event = click_event.event;
      const source_event_id = calendar_event?.extendedProps?.source_event_id ?? calendar_event?.id;

      const selected_from_extended_props = calendar_event?.extendedProps?.event || null;
      const selected_from_events = this.events?.find(item => String(item.id) === String(source_event_id)) || null;
      const selected_from_my_events = this.my_events?.find(item => String(item.id) === String(source_event_id)) || null;

      this.selected_event = selected_from_extended_props || selected_from_events || selected_from_my_events;

      if (!this.selected_event) {
        console.warn("PortalEvents.handle_event_click: could not resolve event for id:", source_event_id);
        Swal.fire({
          icon: 'error',
          title: 'Event not found',
          text: 'Unable to load the selected event details. Please refresh and try again.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 2500,
          toast: true
        });
        return;
      }

      this.close_calendar_more_popover();
      $("#view_event").modal("show");
    },
    calculate_subtotal() {
      return (this.event_tickets || []).reduce((sum, ticket) => {
        const quantity = Number(ticket?.quantitySelected || 0);
        const price = Number(ticket?.price || 0);
        return sum + quantity * price;
      }, 0);
    },
    calculate_total() {
      const sub_total = this.calculate_subtotal();
      const promo = this.applied_promo;
      if (!promo) return sub_total.toFixed(2);

      const promoType = String(promo?.promo_code?.promo_code_type?.name || "").toLowerCase();
      const discountAmount = Number(promo?.promo_code?.discount_amount || 0);

      let total = sub_total;
      if (promoType === "percentage") {
        const percentage = Math.min(Math.max(discountAmount, 0), 100);
        total = sub_total - (sub_total * percentage) / 100;
      } else {
        total = sub_total - Math.max(discountAmount, 0);
      }

      total = Math.max(total, 0);
      return total.toFixed(2);
    },
    validate_ticket_date(ticket_start_date) {
      if (!ticket_start_date) return true;
      const targetDate = new Date(ticket_start_date);
      const today = new Date();
      return !(targetDate > today);
    },
    reset_promo() {
      this.promo_input = "";
      this.promo_message = "";
      this.promo_status = "";
      this.is_applying = false;
      this.applied_promo = null;
    },
    apply_promo() {
      const promo_code_name = (this.promo_input || "").trim();
      const event_id = this.selectedEvent?.id;
      if (!promo_code_name) return;

      if (!event_id) {
        this.promo_status = "error";
        this.promo_message = "Please select an event first.";
        return;
      }

      this.is_applying = true;
      this.promo_message = "";
      this.promo_status = "";

      const token = get_token();
      const headers = token
        ? {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          }
        : { "Content-Type": "application/json" };

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/validate_event_promo_code/`,
        data: JSON.stringify({ promo_code_name, event_id }),
        processData: true,
        contentType: "application/json",
        headers,
        success: (response) => {
          if (response.status === "success") {
            this.applied_promo = response.data || null;
            this.promo_status = "success";
            this.promo_message = response.message || "Promo code applied.";
          } else {
            this.applied_promo = null;
            this.promo_status = "error";
            this.promo_message = response.message || "Invalid promo code.";
          }
        },
        error: (xhr) => {
          this.applied_promo = null;
          this.promo_status = "error";
          this.promo_message =
            xhr?.responseJSON?.message || "Invalid promo code for this event.";
        },
        complete: () => {
          this.is_applying = false;
        },
      });
    },
    go_to_manage_event(event) {
      const eventId = event?.id;
      if (!eventId) return;
      $("#view_event").modal("hide");
      this.$router.push({ name: "manage_event", params: { event_id: eventId } });
    },
    go_to_view_event(event) {
      const eventId = event?.id;
      if (!eventId) return;
      $("#view_event").modal("hide");
      this.$router.push({ name: "view_event", params: { event_id: eventId } });
    },
    can_manage_selected_event() {
      if (!this.token_exists || !this.selected_event) return false;
      const isOwner = String(this.selected_event?.user?.id) === String(this.get_user_id());
      const isAdmin = this.user_details?.user_role === "admin" || this.portal_admin;
      return isOwner || isAdmin;
    },
    handleDateClick(date){
      let formattedDateTime = date.dateStr;

      if (formattedDateTime.length === 10) {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        formattedDateTime += `T${hours}:${minutes}`;
      }
      else {
        formattedDateTime = formattedDateTime.substring(0, 16);
      }
      this.start_date = formattedDateTime;
      this.end_date = formattedDateTime;
      $("#event_modal").modal("show");
    },
   resizeCalendar() {
  this.$nextTick(() => {
    if (this.$refs.calendar) {
      const api = this.$refs.calendar.getApi();
      if (api) api.updateSize();
    }
  });
},
    handleFileUpload(event) {

      const file = event.target.files[0];

      if (file) {
        if (file.type.startsWith("audio/")) {
          this.fileError = "Audio files are not allowed.";
          this.upload_media = null;
          this.fileName = "";
          this.imagePreview = null; // Reset preview if an invalid file is selected
          event.target.value = ""; // Clear file input
        } else {
          this.fileName = file.name;
          this.fileError = "";
          this.upload_media = file;

          // Check if the file is an image before previewing
          if (file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
          } else {
            this.imagePreview = null; // Reset preview for non-image files
          }
        }
      } else {
        this.fileName = "";
        this.fileError = "";
        this.upload_media = null;
        this.imagePreview = null;
      }
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
    getToken() {
      return get_token();
    },
    startScanning(eventId) {
      this.currentEventId = eventId;
      $("#view_event").modal("hide");
      $("#scanModal").modal("show");
    
      $("#scanModal").on("shown.bs.modal", () => {
        this.scanning = true;
        this.startCamera();
      });
    },
        startCamera() {
      const video = document.getElementById("video");
      const canvas = document.getElementById("canvas");
      const context = canvas.getContext("2d");
    
      navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } })
        .then(stream => {
          this.videoStream = stream;
          video.srcObject = stream;
          video.setAttribute("playsinline", true);
          requestAnimationFrame(() => this.scanLoop(video, canvas, context));
        })
        .catch(err => console.error("Camera error:", err));
    },
    
    scanLoop(video, canvas, context) {
      if (!this.scanning) return;
    
      if (video.readyState === video.HAVE_ENOUGH_DATA) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
    
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height, { inversionAttempts: "dontInvert" });
    
        if (code) {
          if (!this.isProcessing) {
            this.isProcessing = true;
            this.scanResult = code.data;
            this.validateTicket(code.data);
    
            setTimeout(() => { this.isProcessing = false; }, 2000);
          }
        }
    
      }
    
      requestAnimationFrame(() => this.scanLoop(video, canvas, context));
    },
    
    stopScanning() {
      this.scanning = false;
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(track => track.stop());
        this.videoStream = null;
      }
      $("#scanModal").off("shown.bs.modal");
      $("#scanModal").modal("hide");
    },
    
        validateTicket(scannedCode) {
    
          this.isScanning = false;
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/scan_event_ticket_qr_code/`,
            method: "POST",
            headers: {
              "Authorization": `Token ${this.getToken()}`,
              "Content-Type": "application/json"
            },
            data: JSON.stringify({
              event_id: this.currentEventId,
              unique_code: scannedCode
            }),
            success: (response) => {
              if (response.status === "success") {
                Swal.fire({
                  icon: "success",
                  title: "Ticket Validated",
                  text: `Ticket ID: ${response.ticket_id}\nEvent: ${response.event}\nTicket Type: ${response.ticket_type}`,
                  confirmButtonText: "OK",
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              } else {
                Swal.fire({
                  icon: "error",
                  text: response.message || "Ticket already used or invalid.",
                  confirmButtonText: "OK",
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            },
            error: (xhr) => {
               Swal.fire({
                  icon: "error",
                  text: xhr.responseJSON.message,
                  confirmButtonText: "OK",
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
               });
    
            }
          });
        },
    get_all_tickets() {

      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_tickets_type/`,
        headers: {
          Authorization: `Token ${this.getToken()}`
        },
        success: (response) => {

          this.allTickets = response.tickets || [];
        },
      });
    },
    newFormatDate(dateString) {
    if (!dateString) return 'N/A';
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleString(undefined, options);
  },
    initializeMap() {
      if (window.google?.maps?.places) {
        const input = this.getActiveMapInput();
        if (!input || (this.map_auto_complete && this.map_auto_complete_input === input)) {
          return;
        }
        this.setupAutocomplete(input);
        return;
      }

      this.loadGoogleMapEvent();
    },

    getActiveMapInput() {
      const activeModal = document.querySelector('.modal.show');
      const modalInput = activeModal?.querySelector('#mapSearchBox');
      if (modalInput) return modalInput;

      const refs = Array.isArray(this.$refs.mapInput) ? this.$refs.mapInput : [this.$refs.mapInput];
      const validRefs = refs.filter(Boolean);
      return (activeModal ? validRefs.find((el) => activeModal.contains(el)) : null) || validRefs[0];
    },

    setupAutocomplete(input) {
      this.map_auto_complete = new window.google.maps.places.Autocomplete(input);
      this.map_auto_complete_input = input;

      this.map_auto_complete.addListener('place_changed', () => {
        const place = this.map_auto_complete.getPlace();
        if (!place?.geometry?.location) return;
        this.location = input.value;
      });
    },

    loadGoogleMapEvent() {
      if (window.google?.maps?.places) {
        this.$nextTick(() => this.initializeMap());
        return;
      }

      const existingScript = document.getElementById('googleMapsPlacesScript');
      if (existingScript) {
        this.$nextTick(() => this.initializeMap());
        return;
      }

      const script = document.createElement('script');
      script.id = 'googleMapsPlacesScript';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places&v=weekly`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.$nextTick(() => this.initializeMap());
      };
      document.head.appendChild(script);
    },
    filter_events() {
      this.token_exists = get_token();
      this.is_filter_events_loading = true;

      const portal_id = this.$route.params.portal_id
      const payload = {

          portal_id: portal_id,
          is_published:true,
          user_id: this.user_id

      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/filter_events_api/`,
        method: "POST",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        data: JSON.stringify(payload),
        success: (data) => {
          const results = data?.data?.results || [];
          this.events = results;
          if (this.initial_calendar_built) {
            results.forEach((ev) => this.upsert_calendar_event(ev));
          }

          setTimeout(() => {
            this.loading = false;
          }, 1000);
        },
        complete: () => {
          this.isLoading = false;
          this.is_filter_events_loading = false;
          this.try_build_initial_calendar();
        },
      });
    },
    cancelRSVP(event_id) {
        const token = this.getToken();
    
        if (!Number.isInteger(event_id)) {
        Swal.fire({
          title: 'Invalid ID',
          text: 'The event ID is not valid.',
          icon: 'error',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }
    
      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/cancel_rsvp/`,
        contentType: 'application/json',
        data: JSON.stringify({ event_id: event_id }),
        headers: {
          'Authorization': `Token ${token}`
        },
        success: (data) => {
          if (data.status === 'success') {
            // Find the event and update is_rsvped to false
            const event = this.events.find(ev => Number(ev.id) === Number(event_id));
            if (event) {
              event.is_rsvped = false;
            }
            Swal.fire({
              icon: 'success',
              title: 'RSVP Cancelled',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
                  $('#event_list_modal').modal('hide');
                })
          }
        },
    
      });
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate();
      const suffix = (d => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      })(day);

      const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
      return `${weekday} ${day}${suffix}`;
    },

    form_time(timeString) {
      if (!timeString) return "";
      const [hour, minute] = timeString.split(":");
      const date = new Date();
      date.setHours(hour, minute);
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },

    daysUntil(dateStr) {
      const today = new Date();
      const eventDate = new Date(dateStr);

      // Zero out time for accurate diff
      today.setHours(0, 0, 0, 0);
      eventDate.setHours(0, 0, 0, 0);

      const diffTime = eventDate - today;
      const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 0) {
        return 'Event has passed';
      } else if (diffDays === 0) {
        return 'Starts today';
      } else if (diffDays < 7) {
        return `Starts in ${diffDays} day${diffDays > 1 ? 's' : ''}`;
      } else {
        const weeks = Math.floor(diffDays / 7);
        const remainingDays = diffDays % 7;
        let result = `Starts in ${weeks} week${weeks > 1 ? 's' : ''}`;
        if (remainingDays > 0) {
          result += ` and ${remainingDays} day${remainingDays > 1 ? 's' : ''}`;
        }
        return result;
      }
    },

    fetchExtras() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_extra/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.extras = data.extras;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    addMoreExtra() {
      const extraItem = {
        selectedExtraText: this.selectedExtraText,
        item_name: this.item_name,
        item_description: this.item_description,
        item_price: this.item_price,
      };
      this.extraForms.push(extraItem);
      this.selectedExtraText = '';
      this.item_name = '';
      this.item_description = '';
      this.item_price = '';
    },

    handleCollapseToggle() {
      this.isCollapseOpen = !this.isCollapseOpen;

      if (this.isCollapseOpen) {
        this.addMoreExtra();
      }
    },
    addExtra() {
      this.show_add_extras = true
      this.showExtrasForm = true;
      this.extraForms.push({
        selectedExtra: "",
        items: [
          { item_name: '', item_description: '', item_price: '' }
        ]
      });
    },

    addExtraItem(extra_index) {
      const extra_form = this.extraForms.at(extra_index);

      if (extra_form) {
        const new_item = {
          item_name: '',
          item_description: '',
          item_price: 0
        };

        if (this.validate_extra_item(new_item)) {
          extra_form.items.push(new_item);
        }
      }
    },

    validate_extra_item(item) {
      return (
        typeof item === 'object' &&
        item !== null &&
        typeof item.item_name === 'string' &&
        typeof item.item_description === 'string' &&
        typeof item.item_price === 'number' &&
        item.item_price >= 0
      );
    },

    removeExtra(extraIndex) {
      this.extraForms.splice(extraIndex, 1);
    },
     selectEvent(event) {
      this.selectedEvent = event;
    },

    fetchEvents_extras(event_id) {
      this.selectEvent.id = event_id;
      this.isLoading = true;
      this.token_exists = get_token();
      this.clearForm()
      this.selectedItemId = []

      // Close the event modal before making the request
      $('#eventModal').modal('hide');

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_data/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { event_id: event_id },
        success: (response_data) => {
          this.eventExtras = response_data.event_extras;
          if (this.eventExtras && this.eventExtras.length > 0) {
            $('#rsvp_modal').modal('show'); // Open RSVP modal
          } else {
            this.addRsvp(); // Call addRsvp if no extra details
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    addRsvp() {

          this.isSubmitting = true;
          const formData = new FormData();
          formData.append('event_id', this.selectedEvent.id);
          if (Array.isArray(this.selectedItemId)) {
            this.selectedItemId.forEach(itemId => {
                formData.append('item_id', itemId);
            });
        } else {
            formData.append('item_id', this.selectedItemId);
        }
        formData.append('business_name', this.businessName || '');
        formData.append('is_first_time', this.isFirstTime ? 'True' : 'False');
        formData.append('chapter', this.chapter || '');
          $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/add_event_rsvp/`,
            data: formData,
            processData: false,
            contentType: false,
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.selectedEvent.is_rsvped = true;
                Swal.fire({
                  icon: 'success',
                  title: 'RSVP Successful',
                  showConfirmButton: false,
                  timer: 2000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
    
                  Swal.close();
    
                  this.selectedEvent = {};
                  this.selectedExtraId = [];
                  this.businessName = '';
                  $('#rsvp_modal').modal('hide');
                });
              }
            },
            complete: () => {
              this.isSubmitting = false;
            }
    
          })
        },
       
    fetchEventTypes() {
      this.isLoading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_types/`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          this.event_types = response.data.event_type;
          this.event_types = this.event_types.map(type => {
            if (type.name === 'in_person') {
              return { ...type, name: 'in person' };
            }
            return type;
          });
          const default_type = this.event_types.find(t => t.name === 'in person'   );

          if (default_type) {
            this.event_type = default_type;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    fetchRecurringTypes() {
      this.isLoading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_recurring_pattern/`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          this.recurring_patterns = response.data.recurring_patterns;
          if (this.initial_calendar_built) {
            this.rebuild_calendar_events();
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
     deleteEvent(event_id) {
          Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            position: 'bottom-end',
            toast: true
          }).then((result) => {
            if (result.isConfirmed) {
              $.ajax({
                type: "DELETE",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/delete_event_api/`,
                data: JSON.stringify({ event_id: event_id }),
                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                  'Content-Type': 'application/json'
                },
                success: (response) => {
                  const status = response.status;
                  if (status === "success") {
                    Swal.fire({
                      title: 'Deleted!',
                      text: 'The event has been deleted.',
                      icon: 'success',
                      showConfirmButton: false,
                      timer: 1000,
                      position: 'bottom-end',
                      toast: true
                    }).then(() => {
                       this.events = this.events.filter(event => event.id !== event_id);
                       this.my_events = (this.my_events || []).filter(event => event.id !== event_id);
                       this.remove_calendar_event(event_id);
                       $('#view_event').modal('hide');
                      Swal.close();
                    });
                  }
                },
                error: (response) => {
                  Swal.fire({
                    title: 'Error!',
                      text: response.responseJSON.message,
                      icon: 'error',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                  }
                    
                  );
                }
              });
            }
          });
        },

    submitEvent() {
      if (this.event_id) {
        this.update_event(this.event_id);
      } else {
        this.submit_event_form();
      }
    },

    load_event() {

      // this.filter_events();

      $("#update_event_modal").modal("hide");
      $('#event_modal').modal('hide');


      this.event_id = null;
      this.event_name = "";
      this.description = "";
      this.start_date = "";
      this.start_time = "";
      this.end_date = "";
      this.end_time = "";
      this.rsvp_start_date = "";
      this.rsvp_start_time = "";
      this.rsvp_end_date = "";
      this.rsvp_end_time = "";
      this.organizer = "";
      this.location = "";
      this.files = [];
    },
    validationEventForm() {
      this.errors = {};
      let valid = true;

      if (!this.event_name) {
        this.errors.event_name = 'Event name is required';
        valid = false;
      }

      return valid;
    },
    clearForm() {
      this.item_name = '';
      this.item_description = '';
      this.item_price = '';
      this.extraItems = [];
      this.event_name = '';
      this.start_date = '';
      this.end_date = '';
      this.event_description = '';
      this.selectedPortalId = '';
      this.organizer = '';
      this.location = '';
      this.rsvp_start_date = '';
      this.rsvp_end_date = '';
      this.upload_media = null;
      this.selectedExtraText = '';
      this.event_type = '';
      if (this.$refs.quillEventEditorRef) {
        this.$refs.quillEventEditorRef.setHTML('');

      };
      this.extraForms = [];

    },
    edit_event(event) {
      $('#view_event').modal('hide');

      this.event_name = event.event_name;
      this.event_id = event.id;
      this.start_date = this.combine_date_time(event.start_date, event.start_time);
      this.end_date = this.combine_date_time(event.end_date, event.end_time);
      this.description = event.description || "";
      if (this.$refs.quillEventEditorRef?.setHTML) {
        this.$refs.quillEventEditorRef.setHTML(this.description);
      }
      this.location = event.location;
      this.is_free=event.is_free
      this.event_link = event.event_link;
      this.portal_id = event.portal_id;
      this.event_type = {
        ...event.event_type,
        name: event.event_type.name.replace(/_/g, ' ')
      }

      $('#event_modal').modal('show');
    },
validate_event_details() {
  let isValid = true;

  if (!this.organizer?.trim()) {
    this.errors.organizer = 'Organizer is required';
    isValid = false;
  }

  if (!this.event_name?.trim()) {
    this.errors.event_name = 'Event name is required';
    isValid = false;
  }

  return isValid;
},

validate_event_location_and_link() {
  let isValid = true;

  if (this.event_type.name === 'hybrid' || this.event_type.name === 'physical') {
    if (!this.location?.trim()) {
      this.errors.location = 'Location is required';
      isValid = false;
    }
  }
  if (this.event_type &&
        (this.event_type.name === 'in_person' || this.event_type.name === 'hybrid') &&
        (!this.location || !this.location.trim())
      ) {
        this.errors.location = 'Location is required for in-person or hybrid events';
        isValid = false;
      }

  if (this.event_type.name === 'online' || this.event_type.name === 'hybrid') {
    if (!this.event_link?.trim()) {
      this.errors.event_link = 'Event link is required for online/hybrid events.';
      isValid = false;
    }
  }

  return isValid;
},
validate_extra_forms() {
  let isValid = true;

  this.extraForms.forEach((extraForm, index) => {
    if (extraForm.selectedExtra) {
      extraForm.items.forEach((item, itemIndex) => {
        if (!item.item_name) {
          this.errors[`extra_${index}_item_${itemIndex}_name`] = "Item name is required.";
          isValid = false;
        }
      });
    }
  });

  return isValid;
},
validate_event_dates() {
  const normalizeDate = (dateStr) => {
    const d = new Date(dateStr);
    return new Date(d.setHours(0, 0, 0, 0));
  };

  const isMissingDateFields =
    !this.start_date || !this.end_date || !this.rsvp_start_date || !this.rsvp_end_date;

  const today = normalizeDate(new Date());
  const startDate = normalizeDate(this.start_date);
  const endDate = normalizeDate(this.end_date);
  const rsvpStart = normalizeDate(this.rsvp_start_date);
  const rsvpEnd = normalizeDate(this.rsvp_end_date);

  const allowedFields = [
    'start_date',
    'end_date',
    'rsvp_start_date',
    'rsvp_end_date'
  ];

  this.errors = {};
  allowedFields.map(field => {
    this.errors = { ...this.errors, [field]: '' };
  });

  let isValid = true;

  const addError = (field, message) => {
    allowedFields.map(f => {
      if (f === field) {
        this.errors = {
          ...this.errors,
          [f]: message
        };
        isValid = false;
      }
    });
  };

  if (isMissingDateFields) {
    const errorMsg = 'All dates are required';
    allowedFields.map(field => addError(field, errorMsg));
    return false;
  }

  if (startDate < today) addError('start_date', 'Start date cannot be in the past');
  if (endDate < startDate) addError('end_date', 'End date must be after start date');
  if (rsvpStart < today) addError('rsvp_start_date', 'RSVP start date cannot be in the past');
  if (rsvpEnd < rsvpStart) addError('rsvp_end_date', 'RSVP end must be after RSVP start');
  if (rsvpEnd > endDate) addError('rsvp_end_date', 'RSVP end must not exceed event end date');

  return isValid;
},
validation_event_form() {
      this.errors = {};
      let isValid = true;

      // 1. Event Name
      if (!this.event_name?.trim()) {
        this.errors.event_name = 'Event name is required';
        isValid = false;
      }

      // 2. Event Type
      if (!this.event_type || !this.event_type.id) {
        this.errors.event_type = 'Please select an event type';
        isValid = false;
      }

      // 3. Organizer
      if (!this.organizer?.trim()) {
        this.errors.organizer = 'Organizer is required';
        isValid = false;
      }

      // 4. Event Link & Location
      if (this.event_type && this.event_type.name) {
        if (this.event_type.name === 'hybrid' || this.event_type.name === 'in_person') {
          if (!this.location?.trim()) {
            this.errors.location = 'Location is required';
            isValid = false;
          }
        }
        if (this.event_type.name === "online" || this.event_type.name === "hybrid") {
          if (!this.event_link?.trim()) {
            this.errors.event_link = "Event link is required for online/hybrid events.";
            isValid = false;
          }
        }
      }

      // 5. Dates and Times
      if (!this.start_date) {
        this.errors.start_date = 'Event Start Date is required';
        isValid = false;
      }
      if (!this.end_date) {
        this.errors.end_date = 'Event End Date is required';
        isValid = false;
      }
      if (!this.rsvp_start_date && this.is_free) {
        this.errors.rsvp_start_date = 'RSVP Start Date is required';
        isValid = false;
      }
      if (!this.rsvp_end_date && this.is_free) {
        this.errors.rsvp_end_date = 'RSVP End Date is required';
        isValid = false;
      }
      if (!this.start_time) {
        this.errors.start_time = 'Start Time is required';
        isValid = false;
      }
      if (!this.end_time) {
        this.errors.end_time = 'End Time is required';
        isValid = false;
      }
      if (!this.rsvp_start_time && this.is_free) {
        this.errors.rsvp_start_time = 'RSVP Start Time is required';
        isValid = false;
      }
      if (!this.rsvp_end_time && this.is_free) {
        this.errors.rsvp_end_time = 'RSVP End Time is required';
        isValid = false;
      }

      // Perform date comparison only if all date fields exist
      if (this.start_date && this.end_date && this.rsvp_start_date && this.rsvp_end_date) {
        const todayObj = new Date();
        const startDateObj = new Date(this.start_date);
        const endDateObj = new Date(this.end_date);
        const rsvpStartDateObj = new Date(this.rsvp_start_date);
        const rsvpEndDateObj = new Date(this.rsvp_end_date);

        todayObj.setHours(0, 0, 0, 0);
        startDateObj.setHours(0, 0, 0, 0);
        endDateObj.setHours(0, 0, 0, 0);
        rsvpStartDateObj.setHours(0, 0, 0, 0);
        rsvpEndDateObj.setHours(0, 0, 0, 0);

        if (startDateObj < todayObj) {
          this.errors.start_date = 'Event Start Date must be today or a future date';
          isValid = false;
        }
        if (endDateObj < startDateObj) {
          this.errors.end_date = 'Event End Date must be after Event Start Date';
          isValid = false;
        }
        if (rsvpStartDateObj > startDateObj) {
          this.errors.rsvp_start_date = 'RSVP Start Date must be today or before Event Start Date';
          isValid = false;
        }
        if (rsvpEndDateObj < rsvpStartDateObj || rsvpEndDateObj > startDateObj) {
          this.errors.rsvp_end_date = 'RSVP End Date must be after RSVP Start Date and on or before Event Start Date';
          isValid = false;
        }
      }

      // 6. Extras Validation
      this.extraForms.forEach((extraForm, index) => {
        if (extraForm.selectedExtra) {
          extraForm.items.forEach((item, itemIndex) => {
            if (!item.item_name?.trim()) {
              this.errors[`extra_${index}_item_${itemIndex}_name`] = "Item name is required.";
              isValid = false;
            }
          });
        }
      });

      if (!this.is_free) {
        this.selectedTicketsData.forEach((ticket) => {
          const key = `ticket_${ticket.id}`;

          // Required checks
          if (!ticket.start_date) {
            this.errors[`${key}_start_date`] = `Start date is required for ${ticket.name}`;
            isValid = false;
          }
          if (!ticket.end_date) {
            this.errors[`${key}_end_date`] = `End date is required for ${ticket.name}`;
            isValid = false;
          }
          if (!ticket.start_date || !ticket.end_date) return;

          const ticket_start_date = new Date(ticket.start_date);
          const ticket_end_date = new Date(ticket.end_date);

          const eventStart = new Date(`${this.start_date} ${this.start_time}`);

          // Logical checks
          if (ticket_start_date >= ticket_end_date) {
            this.errors[`${key}_end_date`] = ` End date must be after start date`;
            isValid = false;
          }

          // Ticket must be valid within event lifecycle
          if (ticket_start_date > eventStart) {
            this.errors[`${key}_start_date`] = `Ticket start cannot be after event start`;
            isValid = false;
          }

          if (ticket_end_date > eventStart) {
            this.errors[`${key}_end_date`] = ` Ticket sale must close before event starts`;
            isValid = false;
          }

        });
      }

      return isValid;
    },
//      validation_event_form() {
//   this.errors = {};
//   let isValid = true;

//   isValid = this.validate_event_details() && isValid;
//   isValid = this.validate_event_location_and_link() && isValid;
//   isValid = this.validate_event_dates() && isValid;
//   isValid = this.validate_extra_forms() && isValid;

//   return isValid;
// },
openModal() {
    this.selectEvent(this.selected_event);
    $("#view_event").modal("hide");
    if (this.selected_event.is_free) {
      $('#eventModal').modal('show');
    } else {
      this.reset_promo();
      this.event_tickets = this.selected_event.event_tickets.map(ticket => ({
        ...ticket,
        quantitySelected: 0
      }));
      $('#ticket_modal').modal('show');
    }
  },
  isEventStarted(event) {
      const now = new Date();
      // Combine date and time for start and end time
      const start = new Date(`${event.start_date}T${event.start_time}`); 
      const end = new Date(`${event.end_date}T${event.end_time}`);
  
      var object={ canJoin: true, message: "" }
      // If the current time is before the event starts (checking both date and time)
      if (now < start) {
          object={ canJoin: false, message: "The event hasn't started yet." }
        return object;
      }
      // If the current time is after the event ends (checking both date and time)
      if (now > end) {
          object={ canJoin: false, message: "The event has ended." }
        return object;

      }
      return object;
    },
    isWithinRSVPPeriod(event) {
      const now = new Date();
      const start = new Date(`${event.rsvp_start_date}T${event.rsvp_start_time}`);
      const end = new Date(`${event.rsvp_end_date}T${event.rsvp_end_time}`);
      if (now < start) {
        return ({ isValid: false, message: "RSVP has not started yet." });
      }
      if (now > end) {
        return ({ isValid: false, message: "RSVP period has ended." });
      }
      return ({ isValid: true, message: "" });
    },
    handle_rsvp(event) {

     if (event.is_free) {

      this.fetchEvents_extras(event.id);
    } else {
      // Paid event → show ticket modal
      this.reset_promo();
      this.event_tickets = event.event_tickets.map(ticket => ({
        ...ticket,
        quantitySelected: 0
      }));
      $('#ticket_modal').modal('show');
    }
  },
    submit_event_form() {
      if (!this.validate_event_date_range?.()) {
        return;
      }
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      const event_url = `${window.location.origin}${this.$route.path}`
      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('event_name', this.event_name);
      formData.append('start_date', this.start_date.split('T')[0]);
      formData.append('start_time', this.start_date.split('T')[1]);
      formData.append('end_date', this.end_date.split('T')[0]);
      formData.append('end_time', this.end_date.split('T')[1]);
      formData.append('portal_id', this.$route.params.portal_id);
      formData.append('location', this.location);
      formData.append('event_type', this.event_type.id);
      if(this.event_link){
        formData.append('event_link', this.event_link);
      }
      formData.append('event_url', event_url)
      formData.append('is_free', this.is_free ? "true" : "false");
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/create_event_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          const status = response.status;
          this.$emit('new_event', response.event)
          Swal.close();
          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Event Created',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#event_modal').modal('hide');
              this.isDropdownVisible = false;
              this.clearForm();
              this.load_event();
              this.events.unshift(response.event);
              this.upsert_calendar_event(response.event);
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.event_name = response_data.message;
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    update_event() {
      Swal.fire({
        title: "Updating...",
        text: "Please wait while we update the event.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const formData = new FormData();
      formData.append("event_id", this.event_id);
      formData.append("event_name", this.event_name);
      const editorRef = this.$refs.quillEventEditorRef;
      this.event_description =
        typeof editorRef?.getHTML === "function"
          ? editorRef.getHTML()
          : (this.description || this.event_description || "");
      formData.append("description", this.event_description);
      formData.append("start_date", this.start_date.split('T')[0]);
      formData.append("start_time", this.start_date.split('T')[1]);
      formData.append('portal_id', this.$route.params.portal_id);
      formData.append("end_date", this.end_date.split('T')[0]);
      formData.append("end_time", this.end_date.split('T')[1]);
      formData.append("organizer", this.organizer);
      formData.append("location", this.location);
      formData.append("event_type", this.event_type.id);
      formData.append('is_free', this.is_free ? "true" : "false");
      if (this.event_link) {
        formData.append("event_link", this.event_link);
      }
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/update_event_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: response.message,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#event_modal').modal('hide');
               const updatedEvent = response.event;
               if(updatedEvent.is_published){
                  this.events = this.events.map(event =>
                  event.id === updatedEvent.id ? updatedEvent : event);
               }
               else{
                  this.my_events = this.my_events.map(event =>
                  event.id === updatedEvent.id ? updatedEvent : event);
               }

               this.upsert_calendar_event(updatedEvent);
            });
          }
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: 'An error occurred while trying to update the Event, please try again.',
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          });
        },
      });
    },

    selectDay(day) {
      if (!day.date) return; // Ensure the day has a valid date

      this.selectedDay = day.dayNumber;
      this.selectedDate = day.date;

      const saDate = new Date(this.selectedDate).toLocaleDateString("en-CA", {
        timeZone: "Africa/Johannesburg",
      });


      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_events_by_date/`,
        method: 'POST',
        data: JSON.stringify({ event_start_date: saDate }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === 'success' && response.events && response.events.length > 0) {
            this.events = response.events;
            this.message = '';
          } else {
            this.events = [];
            this.message = 'No events found.';
          }
        },
        error: () => {
          this.events = [];
          this.message = 'No events found.';
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    process_to_checkout() {
    
        const selectedTickets = this.event_tickets
          .filter(t => t.quantitySelected > 0)
          .map(t => ({
            ticket_id: t.id,
          quantity: t.quantitySelected,
    
          }));
        if (selectedTickets.length === 0) {
          Swal.fire({
            title: "No tickets selected",
            text: "Please choose at least one ticket.",
            icon: "warning",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          return;
        }
    
    
      const request_data = {
        event_id: this.selectedEvent.id,
        user_id: this.user_details.user_id,
        tickets: selectedTickets,
        event_promo_code_id: this.applied_promo ? this.applied_promo.id : this.applied_promo,
      };
    
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/ticket_purchase_api/`,
        method: "POST",
         headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(request_data),
        success: (response) => {
          if (response.status === "success") {
    
            const orderData = response.data;
            $('#ticket_modal').modal('hide'); $('.modal-backdrop').remove();
            this.$router.push({ name: 'checkout', params: { order_id: orderData.id } });
    
          }
        },
        error: (xhr) => {
          Swal.fire({
            title: "Error",
            text: "Failed to create order.",
            icon: "error",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          console.error("AJAX error:", xhr.responseText);
        }
      });
    
      },
      view_attendees(event) {
      const event_id=event.id

      $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_ticket_instances/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({ event_id }),
          success: (data) => {
            this.event_ticket_attendees = data.instances;
            this.isSubmitting = false;
            $('#event_user_ticket').modal('show');
          },
          complete: () => {
            this.isLoading = false;
          }
        });
    },

    exportToCSV(event) {
      if (!event || !event.rsvp_list || event.rsvp_list.length === 0) {
        Swal.fire({
          icon: 'warning',
          text: 'No RSVP data available for export.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }
    
      const isCBO = this.cbo_domain; // Assuming this.cbo_domain is reactive
    
      let csvHeader = "First Name,Last Name,Email,Phone Number,Event";
      if (isCBO) {
        csvHeader += ",Business Name,First Time Attending,Chapter";
      }
      csvHeader += ",Meal\n";
    
      const csvRows = event.rsvp_list.map(user => {
        const firstName = user.user?.first_name || "";
        const lastName = user.user?.last_name || "";
        const email = user.user?.email || "";
        const phoneNumber = user.user?.phone_number || "";
        const eventName = user?.event_name || "";
        const meals = user.rsvp_items?.map(item => item.item?.item_name).join(", ") || "";
    
        let row = `${firstName},${lastName},${email},${phoneNumber},${eventName}`;
    
        if (isCBO) {
          const businessName = user.business_name || "";
          const firstTime = user.is_first_time ? "Yes" : "No";
          const chapter = user.chapter || "";
          row += `,${businessName},${firstTime},${chapter}`;
        }
    
        row += `,"${meals}"`;
    
        return row;
      });
    
      const csvContent = csvHeader + csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
    
      const a = document.createElement("a");
      a.href = url;
      a.download = event.event_name + ".csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

     exportTicketsToCSV(event_ticket_attendees) {
      // Updated to match your ticket buyer data structure
      let csvHeader = "First Name,Last Name,Email,Event Name,Ticket Name,Unique Code,Order Date,Is Redeemed,Is Sold,Updated At\n";
      if (!event_ticket_attendees || event_ticket_attendees.length === 0) {
        Swal.fire({
          icon: 'warning',
          text: 'No ticket buyer data available for export.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }
      const csvRows = event_ticket_attendees.map(user => {
        const firstName = user.first_name || "";
        const lastName = user.last_name || "";
        const email = user.email || "";
        const eventName = user.event_name || "";
        const ticketName = user.ticket_name || "";
        const uniqueCode = user.unique_code || "";
        const orderDate = user.order_date || "";
        const isRedeemed = user.is_redeemed ? "Yes" : "No";
        const isSold = user.is_sold ? "Yes" : "No";
        const updatedAt = this.user.updated_at || "";
        return `${firstName},${lastName},${email},${eventName},${ticketName},${uniqueCode},${orderDate},${isRedeemed},${isSold},${updatedAt}`;
      });
      const csvContent = csvHeader + csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "ticket_buyers_export.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    is_valid_event() {
    return (this.has_valid_basic_info &&
           this.has_valid_location_and_link &&
           this.has_valid_dates);
  },
  has_valid_basic_info() {
    return !!(this.event_name?.trim() && this.event_type?.id);
  },
  has_valid_location_and_link() {
      const typeName = this.event_type?.name;
      if (!typeName) return false;
      const needsLocation = ['hybrid', 'in person'].includes(typeName);
      const needsLink = ['hybrid', 'online'].includes(typeName);
      if (needsLocation && !this.location?.trim()) return false;
      if (needsLink && !this.event_link?.trim()) return false;
      return true;
    },
  has_valid_dates() {
      const startObj = this.get_event_start_date_time?.();
      if (!startObj) return false;
      const now = new Date();
      if (startObj < now) return false;

      const shouldValidateEnd = !!this.end_date || !!this.end_time || !!this.show_event_end_date;
      if (shouldValidateEnd) {
        const endObj = this.get_event_end_date_time?.();
        if (!endObj) return false;
        if (startObj >= endObj) return false;
      }

      return true;
    },
    validate_event_date_range() {
      // Clear first so the UI updates as the user edits.
      this.errors.start_date = null;
      this.errors.end_date = null;

      const startObj = this.get_event_start_date_time();
      const now = new Date();
      if (startObj < now) {
        this.errors.start_date = 'Event start date/time cannot be in the past';
        return false;
      }

      const endObj = this.get_event_end_date_time();
      if(startObj && endObj){
        if (startObj >= endObj) {
          this.errors.end_date = 'event end date must be greater than the start date';
          return false;
        }
      }
      return true;
    },
    get_event_start_date_time() {
      if (!this.start_date) return null;

      // datetime-local uses 'YYYY-MM-DDTHH:mm'
      if (String(this.start_date).includes('T')) return this.parse_local_date_time(this.start_date);

      // date + time inputs
      if (!this.start_time) return null;
      return this.parse_local_date_time(this.start_date, this.start_time);
    },
    get_event_end_date_time() {
      if (!this.end_date) return null;

      if (String(this.end_date).includes('T')) return this.parse_local_date_time(this.end_date);

      if (!this.end_time) return null;
      return this.parse_local_date_time(this.end_date, this.end_time);
    },
    parse_local_date_time(dateStr, timeStr) {
      if (!dateStr) return null;

      let d = dateStr;
      let t = timeStr;

      if (typeof d !== 'string') d = String(d);
      if (t != null && typeof t !== 'string') t = String(t);

      if (d.includes('T')) {
        const parts = d.split('T');
        d = parts[0];
        t = parts[1] || '';
      }

      if (!t) return null;

      const [y, m, day] = d.split('-').map((x) => Number(x));
      const [hh, mm, ss] = t.split(':').map((x) => Number(x));
      if (!y || !m || !day || Number.isNaN(hh) || Number.isNaN(mm)) return null;

      return new Date(y, m - 1, day, hh, mm, Number.isFinite(ss) ? ss : 0, 0);
    },
    get_user_events (reset = false){
        if (reset) {
          this.my_events_page = 1;
          this.my_events_has_more = true;
          this.my_events_total_pages = 0;
          this.my_events = [];
        }
    
        if (!this.my_events_has_more && !reset) return;
    
        // Only show the big loader on first page; use a smaller "loading more" state for pagination.
        this.is_my_events_loading = this.my_events_page === 1;
        this.is_my_events_loading_more = this.my_events_page > 1;
        this.is_user_events_loading = true;
    
        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_user_events/`,
           headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
          data: JSON.stringify({
            page: this.my_events_page,
            page_size: this.my_events_page_size,
            is_published: false,
            portal_id: this.$route.params.portal_id,
          }),
          success: (response) => {
            const status = response.status;
            if (status === "success") {
              const payload = response?.data || {};
              const results = payload.results || [];

              if (this.my_events_page === 1) {
                this.my_events = results;
              } else {
                this.my_events = [...this.my_events, ...results];
              }

              this.my_events_total_pages = Number(payload?.total_pages || 0);
              this.my_events_has_more = !!payload?.has_more;
              if (this.initial_calendar_built) {
                results.forEach((ev) => this.upsert_calendar_event(ev));
              }
            }
          },
          error: (response) => {
            this.is_my_events_loading = false;
            this.is_my_events_loading_more = false;
            this.is_user_events_loading = false;
            Swal.fire({
              title: 'Error!',
              text: response.responseJSON.message,
              icon: 'error',
            }
            );
          },
          complete: () => {
            this.is_user_events_loading = false;
            this.try_build_initial_calendar();
          },
        });
      },
      combine_date_time(datePart, timePart) {
      if (!datePart) return "";
      const safeDate = String(datePart).split('T')[0].trim();
      if (!timePart) return safeDate;

      let safeTime = String(timePart).trim();
      // Accept "HH:mm", "HH:mm:ss", "HH:mm:ssZ", "HH:mm:ss+02:00"
      safeTime = safeTime.replace(/Z$/i, '');
      safeTime = safeTime.replace(/([+-]\d{2}:?\d{2})$/i, '');
      safeTime = safeTime.split('.')[0];
      safeTime = safeTime.slice(0, 5); // "HH:mm"

      if (!safeTime || !safeTime.includes(':')) return safeDate;
      return `${safeDate}T${safeTime}`;
    },
    check_description(html) {
    if (!html) return false;
    const plainText = html.replace(/<[^>]*>/g, '').trim();
    return plainText.length > 0;
    },
    show_ticket_rsvp_card (event) {
      if (!this.token_exists || !event) return false;
      return this.user_details?.user_role !== "admin" || String(event?.user?.id) !== String(this.user_id);
    },
  },
};
